import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"bridge-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M1 17.4468C2.73389 16.7309 3.33756 13.9873 4 12C6 6 9 4 12 4C15 4 18 6 20 12C20.6624 13.9873 21.2661 16.7309 23 17.4468V20H15V14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14V20H1V17.4468Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M1 17.4468C2.73389 16.7309 3.33756 13.9873 4 12C6 6 9 4 12 4C15 4 18 6 20 12C20.6624 13.9873 21.2661 16.7309 23 17.4468V20H15V14C15 12.3431 13.6569 11 12 11C10.3431 11 9 12.3431 9 14V20H1V17.4468Z","strokeWidth":"props.strokeWidth"}}]}]};

const Bridge2 = Vue.extend<IconProps>({
  name: 'Bridge2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'bridge-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Bridge2;
